var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.currentSetupStep > -1)?_c('div',{class:{
    'sc-progress mt-2 mb-4 sc-progress-3': true
  }},[_c('div',{staticClass:"progress-track"}),_vm._l((_vm.steps),function(step,index){return _c('div',{key:step,class:{
        'progress-step': true,
        'is-complete': _vm.currentSetupStep > index,
        'is-active': _vm.currentSetupStep === index
      }},[_c('IconCheck'),_c('label',[_vm._v(_vm._s(step))])],1)})],2):_vm._e(),(_vm.routeReady)?_c('router-view'):_c('Loading',{staticClass:"text-center"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }